export default "__VITE_ASSET__BglVj8ZF__"